import { createStore, Effect } from 'effector';

import { applyReducers } from '@m/effector-utils';
import { User } from '@m/types/api';

import { getCurrentUser, logout } from './actions';

import type { DoneHandler } from '@m/effector-utils';
import type { APIResponse } from '@m/utils/http';

type State = {
  authenticated: boolean | null;
  currentUser: User | null;
  isMetropolisUser: boolean;
};

export const initialState: State = {
  authenticated: null,
  currentUser: null,
  isMetropolisUser: false,
};

const store = createStore(initialState);

type Reducers = {
  getCurrentUser: {
    action: Effect<void, APIResponse>;
    done: DoneHandler<void, State>;
  };
  logout: {
    action: Effect<Parameters<typeof logout>[0], APIResponse>;
    done: DoneHandler<Parameters<typeof logout>[0], State>;
  };
};

export const reducers: Reducers = {
  getCurrentUser: {
    action: getCurrentUser,
    done: (state, { result: { success, data } = {} }) => ({
      ...state,
      authenticated: !!success,
      currentUser: success ? data.user : null,
      isMetropolisUser: data.operators?.some(
        (each: { id: number; name: string; uuid: string }) => each.name === 'Metropolis',
      ),
    }),
  },
  logout: {
    action: logout,
    done: (state, { result: { success } = {} }) => ({
      ...state,
      authenticated: success ? false : state.authenticated,
      currentUser: success ? null : state.currentUser,
    }),
  },
};

export default applyReducers({ storeName: 'admin/auth', store, reducers });
